import { mdiAlertCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import useColorModeValue from '@/hooks/useColorModeValue'

import AnswerMarkDown from './components/AnswerMarkDown'

const ErrorMessage = ({ message }: { message?: string }) => {
    const { t } = useTranslation()
    return (
        <Flex
            alignItems="flex-start"
            bgColor={useColorModeValue('var(--chakra-colors-gray-100)', 'var(--chakra-colors-dark-100)')}
            borderRadius="4px"
            direction="row"
            padding="12px 16px"
            mt="4px"
        >
            <Box width="14px" mt="2px">
                <Icon path={mdiAlertCircleOutline} color="var(--chakra-colors-status-error)" size={0.7} />
            </Box>
            <Box
                fontSize="14px"
                pl="10px"
                color={useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')}
                letterSpacing="0.25px"
                lineHeight="20px"
                data-testid="conversation-message"
            >
                <AnswerMarkDown answer={message || t('global.error.nullAnswer')} />
            </Box>
        </Flex>
    )
}

export default ErrorMessage
